// Debug environment variables
// console.log('Environment variables:', {
//   REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
//   REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
//   window_location: window.location.href,
// });

// Function to get the correct API base URL
const getApiBaseUrl = () => {
  // For testing, use localhost
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3000';
  }

  // Check if we're in production (deployed)
  if (window.location.hostname === 'wm.omgpackagings.com') {
    return 'https://wmapi.omgpackagings.com';
  }

  // Use environment variable, removing trailing slash if present
  const envUrl = process.env.REACT_APP_API_BASE_URL;
  if (envUrl) {
    return envUrl.replace(/\/$/, '');
  }

  // Fallback
  return 'https://wmapi.omgpackagings.com';
};

export const config = {
  apiBaseUrl: getApiBaseUrl(),
  environment: process.env.REACT_APP_ENVIRONMENT || 'development',
  isDevelopment: process.env.REACT_APP_ENVIRONMENT === 'development',
  isProduction: process.env.REACT_APP_ENVIRONMENT === 'production',
};

// Debug final config
// console.log('Final config:', config);

export default config;
